import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex'
import { GenericModal } from 'src/components/Modals/GenericModal'
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

interface InfoModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  mode: 'Presentations' | 'Generations';
}

const InfoModal = ({ isOpen, setIsOpen, mode }: InfoModalProps) => {
  const bodyText = `Your credit balance shows the total number of ${mode} remaining for your organization. Credits replenish on the first day of each month. Contact Stackline customer support to increase your credit balance.`;

  return (
    <GenericModal open={isOpen} onClose={() => setIsOpen(false)} sx={{
      '& .MuiPaper-root': {
        width: '500px'
      },
      '.genericModal__header': {
        paddingBottom: '12px'
      },
      '.genericModal__footer': {
        borderTop: 'none',
        position: 'relative',
        padding: '20px 0 0',
      }
    }}>
      <GenericModal.Header title="Credit balance" onClose={() => setIsOpen(false)} />
      <GenericModal.Body>
        <Text variant="body2" lineHeight="20px">
          {bodyText}
        </Text>
      </GenericModal.Body>
      <GenericModal.Footer>
        <Flex justifyContent="flex-end" gap={16}>
          <SlButton onClick={() => setIsOpen(false)}>Cancel</SlButton>
          <SlButton href="mailto:support@stackline.com" variant="contained" onClick={() => setIsOpen(false)}>
            Contact
          </SlButton>
        </Flex>
      </GenericModal.Footer>
    </GenericModal>
  )
}

export default InfoModal;
